<div class="layout-content">
	<div class="grid">
		<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
			<p-tag icon="pi cm-alert" [value]="('NEW_PRESS_BUTTON_TO_ACQUIRE_1' | translate) + ': ' + loadingValue + ' s'"
				severity="warning"></p-tag>
		</div>
		<div class="col-12">
			<div> <!-- *ngIf="boardUserAcquiring"> -->
				<div class="flex align-items-center justify-content-center w-full">
					<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
				</div>
			</div>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</div>
